module.exports = __webpack_public_path__ + "img/layanan-motor.d1dd07d4.webp";